import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
export var MessagesList = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  font-family: 'MagaluTextos', sans-serif;\n  max-width: 1280px;\n  margin: auto;\n  height: 100%;\n"])));